"use strict";
/*
 * Created on 12 03 2018
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var utils_1 = require("../../core/utils");

var VendorAllowanceBonus_1 = require("../model/VendorAllowanceBonus");

var VendorAllowanceBonusConverter_1 = require("./VendorAllowanceBonusConverter");
/**
 * Implementation of {@link VendorAllowanceBonusConverter}
 *
 * @author JMe
 */


var VendorAllowanceBonusConverterImpl =
/*#__PURE__*/
function (_VendorAllowanceBonus) {
  _inherits(VendorAllowanceBonusConverterImpl, _VendorAllowanceBonus);

  function VendorAllowanceBonusConverterImpl() {
    _classCallCheck(this, VendorAllowanceBonusConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(VendorAllowanceBonusConverterImpl).apply(this, arguments));
  }

  _createClass(VendorAllowanceBonusConverterImpl, [{
    key: "toDocument",

    /**
     * @inheritDoc
     */
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, {
        productId: conversions.toDocumentReferenceId(source.productId),
        withBackBonus: source.withBackBonus ? conversions.fromBigNumber(source.withBackBonus) : null,
        withoutBackBonus: source.withoutBackBonus ? conversions.fromBigNumber(source.withoutBackBonus) : null
      });
      return result;
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toObject",
    value: function toObject(source, conversions) {
      return new VendorAllowanceBonus_1.VendorAllowanceBonus(VendorAllowanceBonus_1.VendorAllowanceBonus.schema.productId.valueOf(conversions.toClassReferenceId(source.productId)), VendorAllowanceBonus_1.VendorAllowanceBonus.schema.withBackBonus.valueOf(!utils_1.Utils.isValueMissing(source.withBackBonus) ? conversions.toBigNumber(source.withBackBonus) : null), VendorAllowanceBonus_1.VendorAllowanceBonus.schema.withoutBackBonus.valueOf(!utils_1.Utils.isValueMissing(source.withoutBackBonus) ? conversions.toBigNumber(source.withoutBackBonus) : null));
    }
  }]);

  return VendorAllowanceBonusConverterImpl;
}(VendorAllowanceBonusConverter_1.VendorAllowanceBonusConverter);

exports.VendorAllowanceBonusConverterImpl = VendorAllowanceBonusConverterImpl;